import React from "react";
import { Link } from "react-router-dom";
import {
  SubscriptionTier,
  TIER_LABELS,
} from "../../../../config/subscriptionConfig";

type Props = {
  requiredTier: SubscriptionTier;
  featureName: string;
  className?: string;
};

const UpgradePrompt: React.FC<Props> = ({
  requiredTier,
  featureName,
  className = "",
}) => {
  return (
    <div
      className={`card border border-primary border-dashed bg-light-primary ${className}`}
    >
      <div className="card-body text-center py-10 px-6">
        <i className="bi bi-lock fs-2x text-primary d-block mb-4"></i>
        <h4 className="text-gray-800 mb-2">{featureName}</h4>
        <p className="text-muted fs-7 mb-5">
          This feature requires the{" "}
          <span className="fw-bold text-primary">
            {TIER_LABELS[requiredTier]}
          </span>{" "}
          plan. Upgrade to unlock {featureName.toLowerCase()} and more.
        </p>
        <Link
          to="/profile/subscription"
          className="btn btn-sm btn-primary"
        >
          Upgrade to {TIER_LABELS[requiredTier]}
        </Link>
      </div>
    </div>
  );
};

export { UpgradePrompt };
